import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';

export default function FileUploadRow({
  buttonLabel,
  name,
  required = false,
  accept = '.pdf,.doc,.docx,.jpg,.jpeg,.png',
  value,
  onChangeName,
  placeholder,
}) {
  const { t } = useTranslation();
  const displayPlaceholder = placeholder || t('careers.modal.form.filePlaceholder');

  return (
    <label className="file-drop ">
      <span className="file-drop-text">{value || displayPlaceholder}</span>

      <Button
        component="span"
        variant="outlined"
        startIcon={<UploadFileIcon />}
        sx={{
          borderColor: '#99191b',
          color: '#99191b',
          borderRadius: '999px',
          textTransform: 'none',
          fontFamily: 'Poppins, sans-serif',
          mt: 1,
          '&:hover': { borderColor: '#e3764c', color: '#e3764c' },
        }}
      >
        {buttonLabel}
      </Button>

      <input
        hidden
        accept={accept}
        // NOTE: leaving "required" on a hidden input blocks form submit (native validation)
        // and prevents our onSubmit handler from running.
        required={false}
        type="file"
        name={name}
        onChange={(e) => onChangeName?.(e.target.files?.[0]?.name || '')}
      />
    </label>
  );
}
